import { Esito } from '@situazioniDaControllare/cassetti-fiscali-da-controllare-models';
import { ModalitaPagamentoF24, UtenteInRegistrazioneRichiestaPiva } from '../forfettari-in-registrazione-folder/forfettari-in-registrazione.models';
import { StatoDichiarazione, TipoContribuzione } from './dichiarazione/dischiarazione.models';

// ForfettApp.BusinessLayer.Utenti.Utente
export interface Forfettario {
    id: number;
    denominazione: string;
    cognome: string;
    nome: string;
    codiceFiscale: string;
    partitaIVA: string;
    indirizzoEmail: string;
    indirizzoEmailRegistrazione: string;
    dataScadenzaAbbonamento: Date;
    sedeInpsId?: string;
    codiceAziendaInps?: string;
    sesso: string;
    dataNascita: Date;
    provinciaNascita: string;
    comuneNascita: string;
    nazione: string;
    indirizzo: string;
    cap: string;
    civico: string;
    citta: string;
    provincia: string;
    indirizzoPEC: string;
    numeroTelefono: string;

    luogoDiEsercizio?: LuogoDiEsercizio;

    atecoUtente: AtecoUtente[];

    providerSdiToken: string;
    indirizzoResidenza: string;
    codiceProvinciaResidenza: string;
    civicoResidenza: string;
    capResidenza: string;
    dugresidenza: string;
    codiceCatastaleResidenza: string;
    dataInizioIva: string;
    dataFineIva?: string;
    fineTrimestreImpostaDiBollo: Date;
    cciaa: string;
    rea: string;
    dataInvioDocumentiRegistrazione: Date;
    dataFirmaDocumentiRegistrazione: Date;
    dataAbilitazioneCassettoFiscale: Date;
    dataFineAbilitazioneCassettoFiscale: Date;
    dataValidazioneCassettoFiscale: Date;
    dataRichiestaCassettoFiscale: Date;
    dataUltimoDownloadCassettoFiscale: Date;
    cassettoFiscaleAffidabile: boolean;
    startUpNel: number;
    firmaDigitale: boolean;
    spid: boolean;
    fatturazioneSdiAttiva: boolean;
    cciaaTipoIscrizione: TipoIscrizioneCCIAA;
    cciaaUnitaLocali: string[];

    isAbbonamentoAttivo: boolean;
    inailCodiceSede: string;
    inailCodiceDitta: string;
    inailCc: string;

    codiceAffiliazione: string;

    registrazioneConSpid: boolean;

    contribuzioniId: number;

    joinDate?: Date;

    bolloInFattura: boolean;
    contributoPrevidenzialeInFattura: boolean;
    fatturazioneACorpo: boolean;

    ibanPredefinito: string;
    ibanF24: string;
    opzioniPagamentoF24: OpzioniPagamentoF24;
    opzioniFattura: OpzioniFattura;
    opzioniCorrispettivo: OpzioniCorrispettivo;
}

// ForfettApp.Api.Controllers.LinksDocumentiRegistrazione
export interface DocumentiRegistrazione {
    dataConfermaDocumentoIdentita: Date;
    dataUploadDocumentoIdentita: Date;
    documentiFirmati: LinkDocumento[];
    documentiGenerati: LinkDocumento[];
    documentoIdentitaFronte: { nome: string; url: string };
    documentoIdentitaRetro: { nome: string; url: string };
    documentoIdentita: LinkDocumento;
}

export interface LinkDocumento {
    nome: string;
    nomeFile: string;
    url: string;
}

export interface LuogoDiEsercizio {
    dug?: string;
    indirizzo?: string;
    civico?: string;
    cap?: string;
    comune?: string;
    provincia?: string;
    codiceCatastale?: string;
}

export interface ForfettarioListItem {
    codiceFiscale: string;
    partitaIVA: string;
    denominazione: string;
    nominativo: string;
    indirizzoEmailRegistrazione: string;
    id: number;
    joinDate: Date;
    dataScadenzaAbbonamento: Date;
}

export interface ParametriAutenticazione {
    username: string;
    password: string;
}

export interface DocumentoIdentita {
    dataConfermaDocumentoIdentita: Date;
    dataUploadDocumentoIdentita: Date;
    documentoIdentitaFronte: { nome: string; url: string };
    documentoIdentitaRetro: { nome: string; url: string };
    documentoIdentita: { nome: string; url: string };
}

export enum StatoDocumentoIdentita {
    daCaricare,
    daConfermare,
    confermato,
}

export interface SetDatiInpsCommand {
    datiContribuzione: DatiContribuzioneInps;
    anno: number;
}

export interface RettificaContribuzioneCommand {
    codiceAziendaINPS: string;
    codiceSedeINPS: string;
    dataCancellazione: Date | null;
    dataIscrizione: Date | null;
    password: string;
    tipoContribuzione: TipoContribuzione;
    segnaDichiarazioneDellAnnoDaGestireAMano: boolean;
    aggiornaTutteDichiarazioniSuccessive: boolean;
}

export interface DatiContribuzioneInps {
    sedeInps: string;
    codiceAziendaInps: string;
}

export interface ConfermaIdentitaPayload {
    dataScadenzaDocumento: Date;
    tipoDocumento: number;
    numeroDocumento: string;
    cropRequestFronte: CropRequestPayload;
    cropRequestRetro: CropRequestPayload;
}

export interface CropRequestPayload {
    rotation: 0 | 1 | 2 | 3;
    cropperPosition: CropperPosition;
}

export interface CropperPosition {
    x1: number;
    y1: number;
    x2: number;
    y2: number;
}

export interface FatturaAttiva {
    id: number;
    tipoDocumento: number;
    utentiId: number;
    nomeCliente: string;
    numero: number;
    numeroBis: number;
    data: Date;
    totale: number;
    impostaDiBollo: number;
    dataPagamento: Date;
    importoPagamento: number;
    statoPagamento: number;
    pdfUrl: string;
    statoInvio: number;
    statoInvioSDI: number;
    contributoPrevidenziale: number;
    totaleAPagare: number;
}

export interface ClassificazioneCosti {
    id: number;
    descrizione: string;
    spiegazione?: string;
    rigoRs?: string;
}

export interface DocumentoAttivo {
    id: number;
    tipoDocumento: TipoDocumentoAttivo;
    utentiId: number;
    codiceFiscale: string;
    clienteId: number;
    tipoCliente: TipoCliente;
    nomeCliente: string;
    atecoId: string;
    enasarco: number;
    speseAnticipate: number;
    numero: number | string;
    numeroBis: number;
    numeroStr: string;
    numeroDocumento: string;
    divisa: string;
    fatturaElettronicaTipoDocumento: string;
    data: Date;
    totale: number;
    totaleAPagare: number;
    totalePagato: number;
    contributoPrevidenziale: number;
    impostaDiBollo: number;
    impostaDiBolloAddebitata: boolean;
    impostaDiBolloGiaPagata: boolean;
    importoPagamento: number;
    statoPagamento: StatoPagamentoFattura;
    statoImportazioneIvaServizi: StatoImportazioneIvaServizi;
    statoInvio: StatoInvioEmail;
    statoInvioSDI: StatoInvioSdi;
    readOnly: boolean;
    pdfUrl: string;
    stornato: boolean;
    documentoStornatoId: number | null;
    providerSdiId: ProviderSdiId;
    tokenInvioSdi: string;
}

export interface ClienteModel {
    id: number;
    tipo: TipoCliente;
    idIva: string;
    partitaIva: string;
    codiceFiscale: string;
    isPubblicaAmministrazione: boolean;
    isStraniero: boolean;
    isClienteSanMarino: boolean;
    denominazione: string;
    deonominazione2: string;
    indirizzo: string;
    cap: string;
    citta: string;
    provincia: string;
    statoEstero: string;
    codiceEnte: string;
    indirizzoEmail: string;
    numeroTelefono: string;
    indirizzoPec: string;
    codiceSDI: string;
    statoCliente: StatoCliente;
    validitaVies: string | null;
}

export enum StatoCliente {
    Normale,
    Preferito,
    Nascosto,
}

export enum TipoCliente {
    PartitaIvaItaliana,
    PartitaIvaIntra,
    PubblicaAmministrazione,
    NonPartitaIva,
    Estero,
}

export const descrizioniTipoClienteLookUp = [
    { value: TipoCliente.PartitaIvaItaliana, description: 'Partita IVA Italiana' },
    { value: TipoCliente.PartitaIvaIntra, description: 'Partita IVA Intra' },
    { value: TipoCliente.PubblicaAmministrazione, description: 'Pubblica Amministrazione' },
    { value: TipoCliente.NonPartitaIva, description: 'Non Partita IVA' },
    { value: TipoCliente.Estero, description: 'Estero' },
];

export enum TipoDocumentoAttivo {
    fattura,
    notaDiCredito,
}

export interface Corrispettivo {
    id: number;
    idUtente: number;
    totale: number;
    data: Date;
    atecoId: string;
}

export enum StatoPagamentoFattura {
    NonPagata = 0,
    ParzialmentePagata = 1,
    Pagata = 2,
}

export enum StatoInvioSdi {
    InvioInCorso = -1,
    NonInviata,
    Inviata,
    Accettata,
    Scartata,
}

export enum StatoImportazioneIvaServizi {
    NonImportata,
    ImportataDagestire,
    ImportataGestita,
}

export enum ErroreInvioSdi {
    FileAllegatoVuoto,
    ServizioMomentaneamenteNonDisponibile,
    UtenteNonAbilitatoAllInvio,
}

export const descrizioniStatoInvioSdiLookUp = [
    { value: StatoInvioSdi.InvioInCorso, description: 'Invio in corso' },
    { value: StatoInvioSdi.NonInviata, description: 'Non inviata' },
    { value: StatoInvioSdi.Inviata, description: 'Inviata' },
    { value: StatoInvioSdi.Accettata, description: 'Accettata' },
    { value: StatoInvioSdi.Scartata, description: 'Scartata' },
];

export enum StatoInvioEmail {
    NonInviata = 0,
    Inviata = 1,
    Elaborata = 2,
    Scartata = 3,
    Consegnata = 4,
    Differita = 5,
    NonConsegnata = 6,
    Aperta = 7,
    Cliccata = 8,
}

export interface FatturaPassiva {
    id: string;
    anno: number;
    fornitoreId: string;
    fornitoreDenominazione: string;
    tipo: string;
    tipoDescrizione: string;
    data: string;
    numero: string;
    importo: number;
    divisa: string;
    classificazioneCosti: string;
    numeroAllegati: number;
    classificazioneCostiId?: number;
    autofattura: DocumentoPassivoAutofattura;
    autofatturaData?: string;
    autoFatturaNumero?: number;
    autoFatturaStatoInvioSdi: StatoInvioSdi;
}

export interface DocumentoPassivoAutofattura {
    utentiId: number;
    dataRicezioneDocumentoPassivo?: string;
    classificazioneCessione?: ClassificazioneCessione;
    numero?: number;
    statoInvioSdi?: StatoInvioSdi;
    tokenInvioSdi: string;
    providerSdiId?: ProviderSdiId;
    data?: string;
    anno: number;
}

export interface Fornitore {
    id: string;
    denominazione: string;
    codiceFiscale: string;
    partitaIva: string;
    indirizzo: string;
    numeroCivico: string;
    cap: string;
    citta: string;
    provincia: string;
    nazione: string;
}

export interface Scadenze {
    id: string;
    documentiPassiviId: string;
    condizioniPagamento: string;
    modalitaPagamento: string;
    importoPagamento: number;
    iban: string;
    beneficiario: string;
    dataScadenzaPagamento: Date;
    codicePagamento: string;
}

export interface Allegati {
    nomeFile: string;
    descrizione: string;
}

export interface FatturaPassivaDettaglio {
    fornitore: Fornitore;
    scadenze: Scadenze[];
    allegati: Allegati[];
    identificativo: string;
    id: string;
    fornitoreId: string;
    fornitoreDenominazione: string;
    tipo: string;
    tipoDescrizione: string;
    data: Date;
    numero: string;
    importo: number;
    tipiDocumentiSpesaId: number;
    numeroAllegati: number;
}

export interface IncassoPagamento {
    id: number;
    tipoDocumento: TipoDocumentoAttivo;
    documentoAttivoId: number;
    data: Date;
    dataDocumento: Date;
    importo: number;
    nota: string;
    modalitaPagamentoId: number;
    modalitaPagamentoDesc: string;
    iban: string;
    totale: number;
    numero: number;
    numeroBis: number;
    numeroDocumentoFe: string;
    denominazioneCliente: string;
}

export enum TipoIncassoPagamento {
    'Incasso',
    'Pagamento',
}

export enum TipoIscrizioneCCIAA {
    DirittoCameralePiccoliImprenditori,
    DirittoCameraleOrdinario,
}

export interface CodiceCCIAA {
    cciaapagamento: string;
    descrizione: string;
    id: boolean;
}
export interface NoyificaPushPayload {
    titolo: string;
    messaggio: string;
    coloreIcona: number;
}

export interface Esercizio {
    anno: number;
    attivo: boolean;
    statoDichiarazione: StatoDichiarazione;
}

// ForfettApp.Domain.Accounts.AccountData
export interface AccountData {
    idUtente: number;
    cognome: string;
    nome: string;
    codicefiscale: string;
    email: string;

    isForfettario: boolean;
    dataScadenzaAbbonamento: string;

    isEmailConfirmed: boolean;
    isDocumentoIdentitaCaricato: boolean;
    isInAttesaCassettoFiscale: boolean;
    isCassettoFiscaleAbilitato: boolean;
    isInAttesaFatturaElettronica: boolean;

    isAbbonamentoSottoscritto: boolean;
    isAbbonamentoScaduto: boolean;
    isAbbonamentoAttivo: boolean;

    utenteConfigurato: boolean;
    eserciziDisponibili: Esercizio[];
    // imposteDiBollo: IImpostadiBolloRaw[];
    refreshFcmRegId: boolean;
    abilitaFatture: boolean;
    abilitaCorrispettivi: boolean;
    // notificheApp: INotificheAppUtenteRaw;
    // ruoli: string[];

    datiRichiestaPiva: UtenteInRegistrazioneRichiestaPiva;
    codiceAffiliazione: string;
    recapito: {
        citta: string;
        indirizzo: string;
        nazione: string;
        cap: string;
        provincia: string;
        numeroTelefono: string;
    };
}

export interface Esercizio {
    anno: number;
    attivo: boolean;
    statoDichiarazione: StatoDichiarazione;
}

export enum ClassificazioneCessione {
    Bene = 0,
    Servizio = 1,
}

export enum TipoDocumentoPassivo {
    Fattura = 'TD01',
    AccontoAnticipoSuFattura = 'TD02',
    AccontoAnticipoSuParcella = 'TD03',
    NotaDiCredito = 'TD04',
    NotaDiDebito = 'TD05',
    Parcella = 'TD06',
    FatturaSemplificata = 'TD07',
    NotaDiCreditoSemplificata = 'TD08',
    DocumentoRiepilogativo = 'TD12',
    AutoFatturaServizi = 'TD17',
    AutoFatturaBeni = 'TD18',
    FatturaDifferita = 'TD24',
    FatturaDifferita_2 = 'TD25',
}

// MODELS API CORE

export interface ComuneDiNascita {
    codiceComuneNascita: string;
    codiceProvinciaNascita: string;
    comuneStatoEsteroNascita: string;
}

// ForfettApp.Api.Models
export interface DocumentiRegistrazione {
    firmaDigitale: boolean;
    registrazioneConSpid: boolean;
    spid?: boolean;
    dataInvioItAgile: Date;
    dataConfermaItAgile: Date;
    dataInvioDocumentiRegistrazione: Date;
    dataFirmaDocumentiRegistrazione: Date;
}

//ForfettApp.Api.Models.DatiIvaModel
export interface DatiIva {
    dataInizioIva: string;
    dataFineIva?: string;
    startUpNel: number;
    readOnly?: boolean;
}

//ForfettApp.Api.Models.DatiContribuzioneModel
export interface DatiContribuzione {
    contribuzioniId: number;
    codiceAziendaInps: string;
    dataIscrizioneCassa: Date;
    dataCancellazioneCassa: Date;
    sedeInpsId: string;
}

//ForfettApp.Api.Models.CameraCommercioModel
export interface CameraCommercio {
    cciaa: string;
    rea: string;
    cciaatipoIscrizione: number;

    unitaLocali: string[];
}

//ForfettApp.Api.Models.CassettoFiscale
export interface CassettoFiscale {
    dataRichiestaCassettoFiscale: Date;
    dataAbilitazioneCassettoFiscale: Date;
    dataValidazioneCassettoFiscale: Date;
    dataFineAbilitazioneCassettoFiscale: Date;
    dataUltimoDownloadCassettoFiscale: Date;
    cassettoFiscaleAffidabile: boolean;
}

//ForfettApp.Api.Models.DocumentiIdentita
export interface DocumentiIdentita {
    dataUploadDocumentoIdentita: Date;
    dataConfermaDocumentoIdentita: Date;
    dataScadenzaDocumentoIdentita: Date;
}

//ForfettApp.Api.Models.Residenza
export interface Residenza {
    dugresidenza: string;
    indirizzoResidenza: string;
    civicoResidenza: string;
    codiceCatastaleComuneResidenza: string;
    codiceProvinciaResidenza: string;
    capResidenza: string;
    comuneResidenza: string;
}

//ForfettApp.Api.Models.Intestazione
export interface Intestazione {
    denominazione: string;
    indirizzo: string;
    citta: string;
    cap: string;
    provincia: string;
}

//ForfettApp.Api.Models.Recapiti
export interface Recapiti {
    numeroTelefono: string;
    indirizzoEmail: string;
    indirizzoPec: string;
    indirizzoEmailAccount?: string;
}

//ForfettApp.Api.Models.OpzioniFattura
export interface OpzioniFattura {
    fatturazioneACorpo: boolean;
    bolloInFattura: boolean;
    contributoPrevidenzialeInFattura: boolean;
    atecoIdFatture: string;
    fatturazioneSdiAttiva: boolean;
    invioSdiAutomatico: boolean;
    providerSdiId: ProviderSdiId;
    providerSdiToken: string;
    abilitaImportazioneGiornaliera: boolean;
    atecoIdImportazioneGiornaliera: string;
    inserisciIncassiFattureImportate: boolean;
    codiceSdiAttuale: string;
}

export enum ProviderSdiId {
    /**
     * @deprecated Rimosso dal sistema - Eliminare una volta che non ci sono più utenti che lo usano
     */
    FatturaPro,
    Fnc,
}

//ForfettApp.Api.Models.PagamentoPredefinitoFattura
export interface PagamentoPredefinitoFattura {
    fattureIBAN: string;
    fattureModalitaPagamentoId: number;
}

//ForfettApp.Api.Models.OpzioniCorrispettivo
export interface OpzioniCorrispettivo {
    atecoId: string;
    rtAtecoId: string;
    abilitaSincronizzazioneRt: boolean;
}

//ForfettApp.Api.Models.OpzioniPagamentoF24
export interface OpzioniPagamentoF24 {
    modalitaPagamentoF24: ModalitaPagamentoF24;
    iban: string;
}

//ForfettApp.Api.Models.Periodicita
export interface Periodicita {
    fineTrimestreImpostaDiBollo: Date;
    fineTrimestreInvioIntrastat: Date;
}

//ForfettApp.Api.Models.OpzioniGraficaFattura
export interface OpzioniGraficaFattura {
    idModelloReportFattura: number;
    coloreModelloReportFattura: string;
}

//ForfettApp.Api.Models.AtecoUtente
export interface AtecoUtente {
    id: number;
    atecoid: string;
    descrizione: string;
    dataInizio: Date;
    dataFine?: Date;
    prevalente?: boolean;
    verificato?: boolean;
    visibile?: boolean;
}

//ForfettApp.Api.Models.DatiInail
export interface DatiInail {
    inailCodiceSede: string;
    inailCodiceDitta: string;
    inailCc: string;
}

// ForfettApp.Api.Models.Utente
export interface Utente {
    nome: string;
    cognome: string;
    codiceFiscale: string;
    partitaIva: string;
    sesso: string;
    codiceAffiliazione: string;

    dataNascita: Date;

    comuneDiNascita: ComuneDiNascita;
    registrazioneConSpid: boolean;
    dataScadenzaAbbonamento: Date;
    datiIva: DatiIva;
    datiContribuzione: DatiContribuzione;
    cassettoFiscale: CassettoFiscale;
    cameraCommercio: CameraCommercio;
    datiInail: DatiInail;
    documentiIdentita: DocumentiIdentita;
    residenza: Residenza;
    intestazione: Intestazione;
    recapiti: Recapiti;
    opzioniFattura: OpzioniFattura;
    pagamentoPredefinitoFattura: PagamentoPredefinitoFattura;
    opzioniCorrispettivo: OpzioniCorrispettivo;
    opzioniPagamentoF24: OpzioniPagamentoF24;
    periodicita: Periodicita;
    opzioniGraficaFattura: OpzioniGraficaFattura;
    atecoUtente: AtecoUtente[];
    luogoDiEsercizio?: LuogoDiEsercizio;
}

export interface ContatoriCriticitaUtente {
    esito: Esito;
    numero: number;
}

export interface DatiUltimaImportazione {
    dataUltimaImportazione?: Date;
}

export interface EsitoDownloadCorrispettiviRt {
    dataUltimaChiusuraLetta?: Date;
    dataUltimoDownload?: Date;
    importoUltimaChiusura: number;
    matricolaRegistratoreUltimaChiusura: string;
}

export interface UpdateOpzioniImportazioneFatturePayload {
    abilitaImportazioneGiornaliera: boolean;
    atecoIdImportazioneGiornaliera: string;
    inserisciIncassiFattureImportate: boolean;
}

export interface UpdateOpzioniSincronizzazioneCorrispettiviPayload {
    abilitaSincronizzazioneRt: boolean;
    atecoId: string;
    rtAtecoId: string;
}
